import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HomeService } from '../../_services';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { LocationStrategy } from '@angular/common';
import {
  Constants,
  LocalStoragerService,
  SessionStoragerService,
} from '../../_utility';
import { Router } from '@angular/router';
import { Restaurant } from '../../_models';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  public shipId: string;
  public datasource: Array<Restaurant> = [];
  public selected!: any;

  constructor(
    private router: Router,
    private spinner: SpinnerService,
    private service: HomeService,
    private lStore: LocalStoragerService,
    private sStore: SessionStoragerService
  ) {
    this.shipId = this.lStore.getElement(Constants.Storager.SHIPID);
  }

  ngOnInit(): void {
    this.Restaurants();
  }

  Restaurants() {
    this.spinner.show();
    this.service.Restaurants(this.shipId).subscribe({
      next: (res) => {
        this.datasource = res;
        this.spinner.hide();
      },
    });
  }

  Continues() {
    if (!!this.selected) {
      this.sStore.setElement(Constants.Storager.RESTAURANT, this.selected);
      this.sStore.setElement(Constants.Storager.AUTOLOGIN, false);
      this.router.navigate(Constants.Routing.SELECT_USER.routerLink);
    }
  }
}
